export default class REModel {
  constructor(inputRegex) {
    this.inputRegex = inputRegex;
  }
}
